import { clientAccountsRoute } from './ClientAccountsPage/route';
import { clientBankInsurancesRoute } from './ClientBankInsurancesPage/route';
import { clientCreateReportsForStateInstitutionsRoute } from './ClientCreateReportsForStateInstitutionsPage/route';
import { clientLoansRoute } from './ClientLoansPage/route';
import { clientPackagesRoute } from './ClientPackagesPage/route';
import { clientCardsClickToPayRoute } from './clientCards/ClientCardsClickToPayPage/route';
import { clientCardsRoute } from './clientCards/ClientCardsPage/route';
import { clientProductsRoute } from './route';

export const clientProductsRoutes = clientProductsRoute.addChildren([
	clientAccountsRoute,
	clientPackagesRoute,
	clientLoansRoute,
	clientBankInsurancesRoute,
	clientCardsRoute,
	clientCreateReportsForStateInstitutionsRoute,
	clientCardsClickToPayRoute,
]);
